import { BehaviorSubject, Observable } from 'rxjs';

export abstract class Store<T> {
  private stateSubject$: BehaviorSubject<T>;
  readonly state$: Observable<T>;

  protected constructor(initialState: T) {
    this.stateSubject$ = new BehaviorSubject<T>(initialState);
    this.state$ = this.stateSubject$.asObservable();
  }

  protected get state(): T {
    return this.stateSubject$.getValue();
  }

  protected setState(nextState: T): void {
    this.stateSubject$.next(nextState);
  }
}
